import { useContext } from 'react';
import { ProductBankDataContext } from '../context/ProductBankDataContext/ProductBankDataContext';

export const useProductBankInputData = () => useContext(ProductBankDataContext);
